import { RadioProps, Radio } from "@mui/material";

export default function XNGRadio(props: RadioProps) {
  return <Radio {...props} size="small" />;
}
